import Controller, { inject as controller } from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { OTA_IDS } from 'frontend-utils/utils/constants/constant-values';
import { isDateCompare } from 'lumen/utils/is-comparing-rates';

export default class HotelRatesExportController extends Controller {
  @service router;

  @controller('hotel.rates') rates;

  get tabsParams() {
    // TEMP CTRIP code
    const hasLiveShop =
      this.rates?.liveupdateEnabled &&
      this.rates?.canLiveShopForOTA &&
      this.rates?.otaId !== OTA_IDS.CTRIP;
    return {
      // Rate options
      maxInterval: 365,
      los: this.rates?.los,
      mealPlan: this.rates?.mealPlan,
      maxPersons: this.rates?.maxPersons,
      roomType: this.rates?.roomType,
      rateParam: this.rates?.rateParam,
      membershipType: this.rates?.membershipType,
      platform: this.rates?.platform,
      rateChanges: this.rates?.rateChanges,
      compareType: this.rates?.compareType,
      compareValue: this.rates?.compareValue,
      // Needs to be bound to rates to enable the correct context
      defaultRateChanges: this.rates?.defaultRateChanges.bind(this.rates),
      compsetId: this.rates?.compsetId,
      otaId: this.rates?.otaId,
      selectedOTA: this.rates?.selectedOTA,
      // Liveupdate options
      liveupdateChecked:
        hasLiveShop && this.rates?.noDataForSelection?.exportDisabled,
      hasLiveShop,
      liveupdateDisabled:
        !isEmpty(this.rates?.compareType) &&
        !isDateCompare(this.rates?.compareType),
    };
  }

  @action
  closeModal() {
    this.router.legacyTransitionTo('hotel.rates');
  }
}
